import React from "react";
import Grid from "@material-ui/core/Grid";
import Hidden from "@material-ui/core/Hidden";
import Paper from "@material-ui/core/Paper";
import Typography from "@material-ui/core/Typography";
import { withStyles as withStylesMUI } from "@material-ui/core/styles";
import cx from "classnames";

import { DynamicWhatsApp } from "../../Chat";
import { withStyles, Styles } from "./styles";

const typographyStyles = ({ typography }) => ({
  body2: {
    ...typography.body2,
    color: "#fff",
    display: "block",
    fontFamily: "Open sans",
    textAlign: "center"
  },
  h5: {
    ...typography.h5,
    color: "#fff",
    fontWeight: 700,
    textAlign: "center"
  }
});

const StyledTypography = withStylesMUI(typographyStyles)(Typography);

export interface LayoutProps extends Styles {
  mainContent: React.ReactElement;
  showTitles?: boolean;
  showWhatsApp?: boolean;
  sideBar?: React.ReactElement;
  subtitle?: string;
  title?: string;
}

const LayoutBase: React.FC<LayoutProps> = ({
  classes,
  mainContent,
  showTitles,
  showWhatsApp,
  sideBar,
  subtitle,
  title
}) => {
  return (
    <div className={classes.container}>
      <Grid className={classes.header}>
        {showTitles && (
          <>
            <StyledTypography variant="h5">{title}</StyledTypography>
            <StyledTypography variant="body2">{subtitle}</StyledTypography>
          </>
        )}
      </Grid>
      <Grid container={true} justify={Boolean(sideBar) ? "flex-start" : "center"}>
        <Grid item={true} xs={12} lg={8}>
          <Paper className={cx(classes.form, { [classes.withSideBar]: Boolean(sideBar) })}>
            {mainContent}
          </Paper>
        </Grid>
        {sideBar ? (
          <Hidden mdDown>
            <Grid item={true} className={classes.space}></Grid>
            <Grid item={true} xs={12} lg={3}>
              <Paper elevation={0}>{sideBar}</Paper>
            </Grid>
          </Hidden>
        ) : null}
      </Grid>
      {showWhatsApp && <DynamicWhatsApp hideInMobile={true} />}
    </div>
  );
};

export const CheckoutLayout = withStyles(LayoutBase);
